const map = {
  // Branäs
  'hyra.branas.se': 'https://booking-api-branas.branasgruppen.se', // Production

  'www.branas.se': 'https://booking-api-branas.branasgruppen.se', // Embedded production
  'branas.se': 'https://booking-api-branas.branasgruppen.se', // Embedded production

  'bokning17.branas.testversion.se': 'http://api.bokning17.branas.testversion.se', // Booking staging
  'branas.testversion.se': 'http://api.bokning17.branas.testversion.se', // Embedded staging
  'www-dev.branas.se': 'http://api.bokning17.branas.testversion.se', // Embedded staging

  // Kungsberget
  'hyra.kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se', // Production

  'www.kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se', // Embedded production
  'kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se', // Embedded production

  'bokning17.kungsberget.testversion.se': 'http://api.bokning17.kungsberget.testversion.se', // Booking staging
  'kungsberget.testversion.se': 'http://api.bokning17.kungsberget.testversion.se', // Embedded staging
  'www-dev.kungsberget.se': 'http://api.bokning17.kungsberget.testversion.se', // Embedded staging

  // Local
  'localhost:3000': 'https://branas-booking-backend.ddev.site', // Local
  'localhost:7080': 'https://branas-booking-backend.ddev.site', // Local
  'branas-webb-branas.ddev.site': 'https://branas-booking-backend.ddev.site', // Embedded local
  'branas-webb-kungsberget.ddev.site': 'https://branas-booking-backend.ddev.site', // Embedded local
};

const host = window.location.host;

if (!window.API_URL) {
  if (localStorage.getItem('branas/api_url')) {
    window.API_URL = localStorage.getItem('branas/api_url');
  } else {
    window.API_URL = map[host];
  }
}

if (!window.API_URL) {
  console.error('No matching API URL!');
}

export const theFunction = () => {
};

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/set-backend-url.js